"use client";

import { FormEvent, useState } from "react";
import { signIn } from "next-auth/react";
import { useRouter } from "next/navigation";
import { LogoMark } from "@/components/LogoMark";

export function LoginForm() {
  const router = useRouter();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError("");
    if (!email.trim()) {
      setError("Enter your email.");
      return;
    }
    if (!password) {
      setError("Enter your password.");
      return;
    }
    setLoading(true);
    const res = await signIn("credentials", {
      email: email.trim().toLowerCase(),
      password,
      redirect: false,
    });
    setLoading(false);
    if (res?.error) {
      setError(
        res.code === "SetupInProgress"
          ? "Your account setup is still in progress. Contact 42Voice."
          : "Invalid email or password."
      );
      return;
    }
    router.refresh();
    router.push("/");
  }

  return (
    <form
      onSubmit={onSubmit}
      className="w-full max-w-[400px] rounded-[20px] border border-white/12 bg-white/[0.04] p-[34px_30px] shadow-[0_30px_70px_rgba(0,0,0,.45)] backdrop-blur-sm"
    >
      <LogoMark light />
      <h1 className="mt-[18px] mb-1 text-[21px] font-bold tracking-tight text-white">
        Client Portal
      </h1>
      <p className="mb-[22px] text-[13.5px] text-[#9fb6c4]">
        Sign in to see how your voice agents are performing.
      </p>

      <div className="mb-3.5">
        <label className="mb-1.5 block text-xs font-semibold tracking-wide text-[#9fb6c4]">
          Email
        </label>
        <input
          type="email"
          autoComplete="username"
          placeholder="you@yourbusiness.co.nz"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full rounded-[11px] border border-white/16 bg-white/[0.06] px-3.5 py-3 text-sm text-white outline-none placeholder:text-[#5f7688] focus:border-teal-bright"
        />
      </div>

      <div className="mb-3.5">
        <label className="mb-1.5 block text-xs font-semibold tracking-wide text-[#9fb6c4]">
          Password
        </label>
        <input
          type="password"
          autoComplete="current-password"
          placeholder="••••••••"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full rounded-[11px] border border-white/16 bg-white/[0.06] px-3.5 py-3 text-sm text-white outline-none placeholder:text-[#5f7688] focus:border-teal-bright"
        />
        <div className="mt-0.5 min-h-[14px] text-xs text-[#ff9b9b]">{error}</div>
      </div>

      <button
        type="submit"
        disabled={loading}
        className="w-full cursor-pointer rounded-[11px] border-0 bg-gradient-to-br from-teal to-teal-deep py-3.5 text-[15px] font-bold tracking-wide text-white transition hover:brightness-105 disabled:opacity-70"
      >
        {loading ? "Signing in…" : "Sign in"}
      </button>

      <div className="mt-4 text-center text-xs text-[#7a91a1]">
        Forgot password?{" "}
        <a className="text-teal-bright no-underline" href="mailto:info@42voice.com">
          Contact 42Voice
        </a>
      </div>
    </form>
  );
}
